import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-assets-page" }
const _hoisted_2 = { class: "asset-groups-header" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "text-muted small" }
const _hoisted_5 = { class: "tab-content mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center gap-3 py-3"
}
const _hoisted_8 = { class: "data-grid-card" }
const _hoisted_9 = { class: "d-flex gap-1 flex-wrap" }
const _hoisted_10 = { class: "d-flex gap-2 justify-content-center" }
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = {
  key: 0,
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_UserAssetFormModal = _resolveComponent("UserAssetFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('aside.menu.pages.userAssets')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('components.userAssets.subtitle')), 1)
      ]),
      _createElementVNode("div", null, [
        (_ctx.canCreate)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-plus-lg me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.addButton')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.listError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.listError), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("span", {
              class: "spinner-border text-primary",
              role: "status"
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.userAssets.loading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DxDataGrid, {
          ref: "gridRef",
          class: "ag-grid",
          "data-source": _ctx.dataSource,
          "remote-operations": true,
          "hover-state-enabled": true,
          "column-auto-width": false,
          "show-borders": true,
          "row-alternation-enabled": true,
          "column-hiding-enabled": true,
          "word-wrap-enabled": true
        }, {
          "roles-template": _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
                  'bg-success': data.data.roles.includes('ROLE_ASSET_OWNER'),
                  'bg-primary': data.data.roles.includes('ROLE_ASSET_ADMIN') && !data.data.roles.includes('ROLE_ASSET_OWNER'),
                  'bg-info': data.data.roles.includes('ROLE_USER') && data.data.roles.includes('ROLE_ASSET') && !data.data.roles.includes('ROLE_ASSET_OWNER')
                }])
              }, _toDisplayString(_ctx.getRoleLabel(data.data.roles)), 3)
            ])
          ]),
          "active-template": _withCtx(({ data }) => [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", data.data.active ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'])
            }, null, 2)
          ]),
          "actions-template": _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    title: _ctx.$t('components.assetGroups.actions.edit'),
                    onClick: ($event: any) => (_ctx.openEditModal(data.data))
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                  ]))], 8, _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.canEdit && !data.data.roles.includes('ROLE_ASSET_OWNER'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-sm btn-outline-danger",
                    title: _ctx.$t('components.userAssets.actions.delete'),
                    onClick: ($event: any) => (_ctx.confirmDelete(data.data))
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
                  ]))], 8, _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary",
                    title: _ctx.$t('components.assetGroups.actions.view'),
                    onClick: ($event: any) => (_ctx.openViewModal(data.data))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                  ]))], 8, _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxHeaderFilter, { visible: true }),
            _createVNode(_component_DxFilterRow, { visible: true }),
            _createVNode(_component_DxPaging, { "page-size": 20 }),
            _createVNode(_component_DxPager, {
              "allowed-page-sizes": [10, 20, 50],
              "show-info": true,
              "show-page-size-selector": true,
              "show-navigation-buttons": true
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "id",
              caption: _ctx.$t('components.userAssets.columns.id'),
              width: "80",
              alignment: "center"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "email",
              caption: _ctx.$t('components.userAssets.columns.email'),
              "min-width": 200
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "name",
              caption: _ctx.$t('components.userAssets.columns.name'),
              "min-width": 150
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "surname",
              caption: _ctx.$t('components.userAssets.columns.surname'),
              "min-width": 150
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "phone",
              caption: _ctx.$t('components.userAssets.columns.phone'),
              "min-width": 140,
              "hiding-priority": 2
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "roles",
              caption: _ctx.$t('components.userAssets.columns.roles'),
              "min-width": 180,
              "allow-filtering": false,
              "hiding-priority": 1,
              "cell-template": "roles-template"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "active",
              caption: _ctx.$t('components.userAssets.columns.active'),
              alignment: "center",
              width: "100",
              "cell-template": "active-template"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              caption: _ctx.$t('components.assetGroups.columns.actions'),
              "allow-filtering": false,
              "allow-sorting": false,
              width: "120",
              alignment: "center",
              "cell-template": "actions-template"
            }, null, 8, ["caption"])
          ]),
          _: 1
        }, 8, ["data-source"]),
        (_ctx.isGridEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('components.userAssets.empty')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_UserAssetFormModal, {
      ref: "userAssetModalRef",
      onSaved: _ctx.handleUserSaved
    }, null, 8, ["onSaved"])
  ]))
}